<template>
  <footer class="footer text-center">
    <p class="white">created by hzzly</p>
  </footer>
</template>

<script>
export default {
  name: 'foot'
}
</script>
